import { facadeFactory } from '@spartacus/core'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { MbBillingInformation, MbPaymentModeSelection } from '../../models'
import { CHECKOUT_CORE_FEATURE } from '@spartacus/checkout/base/root'

@Injectable({
  providedIn: 'root',
  useFactory: () =>
    facadeFactory({
      facade: MbCheckoutBillingFacade,
      feature: CHECKOUT_CORE_FEATURE,
      methods: [
        'postBillingInformation',
        'postBillingStepForm',
        'notifyPoNumberFieldValidity',
        'openCardView',
        'closeCardView',
        'setSelectedPaymentMode'
      ],
      properties: [
        'isPoNumberFieldInvalid',
        'isCardViewAndPaymentVisible',
        'isDisplaySimpleButtons',
        'selectedPaymentModeSelection'
      ],
      async: true,
    }),
})
export abstract class MbCheckoutBillingFacade {
  abstract get isPoNumberFieldInvalid(): Observable<boolean>
  abstract get isCardViewAndPaymentVisible(): Observable<boolean>
  abstract get isDisplaySimpleButtons(): Observable<boolean>
  abstract get selectedPaymentModeSelection(): Observable<MbPaymentModeSelection>

  /**
   * Makes POST request to backend to post form
   */
  abstract postBillingInformation (form: any, cartID: string, userID: string): void

  /**
   * Shared method to post the billing information form
   */
  abstract postBillingStepForm (billingInformation: MbBillingInformation): void

  /**
   * Notify invoice field validity
   */
  abstract notifyPoNumberFieldValidity(isValid: boolean): void

  /**
   * Opens/Shows the card view
   */
  abstract openCardView(): void

  /**
   * Closes/Hides the card view
   */
  abstract closeCardView (): void

  /**
   * Sets the payment mode
   */
  abstract setSelectedPaymentMode (paymentModeSelection?: MbPaymentModeSelection): void
}
